import { IGetEntregaObraReportGeralDropDownUseCase } from "../../../presentation/useCases/read/get_report_geral_entrega_obra_drop_down_use_case";
import { DropDown } from "../../models/dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetEntregaObraReportGeralDropDownUseCase
 */

export class GetEntregaObraReportGeralDropDownUseCase implements IGetEntregaObraReportGeralDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async execute(idEntregaObra: number, tipo: string): Promise<DropDown[]> {
    return await this.repository.getReportEntregaObraGeralDropDown(idEntregaObra, tipo);

  }
}
